module.exports = {
	"articleTitle1": "All roads lead to Fleetwood ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Fleetwood Diner",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/lilas-column",
	"articleSnippet1": "Apr 5, 2017 ... Welcome to the Fleetwood Diner. Just hugging the edge of downtown Ann Arbor, \nFleetwood squats at the corner of two intersecting streets, ...",
	"articleSnippet2": "Nov 11, 2009 ... Ann Arbor's most adored greasy spoon, the Fleetwood Diner, is at the \nintersection of Ashley and Liberty Streets on the edge of downtown.",
	"foodRecommendations": [
		{
			"text": "Really solid breakfast food at all hours, can't go wrong with one of the hashes.",
			"person": "Nick Kortman"
		},
		{
			"text": "Hippie hash til I die.",
			"person": "Ben Iaderosa"
		}
	],
	"articleTitle2": "Lila Kalick: Hippie hash, spunky clientele and greasy spooning at ...",
	"address": "300 S Ashley St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/agc.NEW_.FleetwoodDiner.4.4.16.0020.online.jpg?itok=GRHMZw8P",
			"author": "Amelia Cacchione",
			"caption": "NOSELL"
		}
	],
	"position": {
		"lat": 42.27948,
		"lng": -83.750046
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/fleetwooddiner.json
// module id = 878
// module chunks = 0